import { InteractionRequiredAuthError } from '@azure/msal-browser';
import msalInstance from '../components/entra/msalInstance';
import { accessTokenRequest, loginRequest } from '../entraConfig';

let tokenPromise = null;

const getAccessToken = async () => {
  if (tokenPromise) {
    return tokenPromise;
  }

  tokenPromise = (async () => {
    try {
      let account = msalInstance.getActiveAccount();

      if (!account) {
        const accounts = msalInstance.getAllAccounts();
        account = accounts.length ? accounts[0] : null;

        if (account) {
          msalInstance.setActiveAccount(account);
        }
      }

      if (!account) {
        await msalInstance.loginRedirect(loginRequest);
        return null;
      }

      const request = {
        ...accessTokenRequest,
        account,
      };

      const response = await msalInstance.acquireTokenSilent(request);
      return response.accessToken;
    } catch (error) {
      console.log('Failed to get token:', error);

      const isInteractionRequired =
        error instanceof InteractionRequiredAuthError ||
        error.errorCode === 'monitor_window_timeout';

      if (isInteractionRequired) {
        await msalInstance.acquireTokenRedirect(accessTokenRequest);
        return null;
      }

      throw error;
    } finally {
      tokenPromise = null;
    }
  })();

  return tokenPromise;
};

export default getAccessToken;
